import { config } from '../../config/env';
import { authInterceptor } from '../Authentication/authInterceptor';

const API_BASE = `${config.api.baseUrl}/auth`;

export interface UserPersonaData {
  primaryPersona?: string;
  traits: string[];
  confidence: number;
  completed: boolean;
}

class PersonaService {
  private headers(): HeadersInit {
    return {
      'Authorization': `Bearer ${authInterceptor.getAccessToken()}`,
      'Content-Type': 'application/json',
    };
  }

  async updateUserPersona(userId: string, primaryPersona: string, personaTraits: string[], personaConfidence: number): Promise<void> {
    const response = await fetch(`${API_BASE}/update-persona`, {
      method: 'POST',
      headers: this.headers(),
      body: JSON.stringify({
        user_id: userId,
        primary_persona: primaryPersona,
        persona_traits: personaTraits,
        persona_confidence: personaConfidence,
      }),
    });
    if (!response.ok) throw new Error(`Failed to update persona: ${response.statusText}`);
  }

  async getUserPersonaData(userId: string): Promise<UserPersonaData | null> {
    const response = await fetch(`${API_BASE}/user-persona?user_id=${encodeURIComponent(userId)}`, {
      headers: this.headers(),
    });
    if (!response.ok) return null;
    const { data } = await response.json();
    return data ?? null;
  }
}

export const personaService = new PersonaService();
